import { Row, Col } from "antd";
import { withTranslation, TFunction } from "react-i18next";
import { SvgIcon } from "../../common/SvgIcon";
import Container from "../../common/Container";
import i18n from "i18next";
import {
  FooterSection,
  Title,
  NavLink,
  Extra,
  LogoContainer,
  Para,
  Large,
  Chat,
  Empty,
  FooterContainer,
  Language,
  Label,
  LanguageSwitch,
  LanguageSwitchContainer,
} from "./styles";

interface SocialLinkProps {
  href: string;
  src: string;
}

const Footer = ({ t }: { t: TFunction }) => {
  const handleChange = (language: string) => {
    i18n.changeLanguage(language);
  };

  const SocialLink = ({ href, src }: SocialLinkProps) => {
    return (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        key={src}
        aria-label={src}
      >
        <SvgIcon src={src} width="25px" height="25px" />
      </a>
    );
  };

  
  return (
    <>
      <FooterSection>
        <Container>
          <Row justify="space-between">
            {/* 1) Texto principal */}
            <Col lg={10} md={10} sm={12} xs={{ span: 24, order: 1 }}>
              <Language>
                {t("Siempre tendrás un lugar a dónde ir y con quién estar.")}
              </Language>
              <br />
              <Para>
                Te proporcionamos sugerencias eventos de tu agrado y la
                posibilidad de interactuar con personas que les gustaría ir al
                mismo evento que tú.
              </Para>
            </Col>

            {/* 2) Accesos relacionados (queremos que vaya justo debajo en mobile) */}
            <Col lg={8} md={8} sm={12} xs={{ span: 24, order: 2 }}>
              <Title>{t("Accesos relacionados")}</Title>
              <br />
              <Large to="/terms">{t("· Términos y Condiciones")}</Large>
              <Large to="/privacy">{t("· Política de Privacidad.")}</Large>
            </Col>

            {/* 3) Síguenos en (tercero en mobile) */}
            <Col lg={6} md={6} sm={12} xs={{ span: 24, order: 3 }} style={{marginTop:"2rem"}}>
              <Label htmlFor="select-lang">{t("Síguenos en")}</Label>
              <LanguageSwitchContainer>
                <LanguageSwitch
                  onClick={() =>
                    window.open(
                      "https://www.facebook.com/share/1ZpXm51AaH/",
                      "_blank"
                    )
                  }
                >
                  <img src="/img/socialFacebook.png" height={38} alt="face" />
                </LanguageSwitch>
                <LanguageSwitch
                  onClick={() =>
                    window.open(
                      "https://www.instagram.com/parrandapp?igsh=MW03aXZuaGJ6Y3loMA==",
                      "_blank"
                    )
                  }
                >
                  <img src="/img/socialinsta.png" height={38} alt="inst" />
                </LanguageSwitch>
              </LanguageSwitchContainer>
            </Col>
          </Row>
        </Container>
      </FooterSection>
    </>
  );
};

export default withTranslation()(Footer);
